export default __webpack_public_path__ + "images/K2.3a1c4dd.png";